import { render } from "./ProfileDistributors.vue?vue&type=template&id=2d81bc8d&scoped=true"
import script from "./ProfileDistributors.vue?vue&type=script&lang=js"
export * from "./ProfileDistributors.vue?vue&type=script&lang=js"

import "./ProfileDistributors.vue?vue&type=style&index=0&id=2d81bc8d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d81bc8d"]])

export default __exports__